import { Dispatch } from 'redux';
import { MockApiHandler } from '../../mock-api/mock-api-model';
import { ApiEndpoint } from '../constants/api-endpoints';
import { ApiAction, HttpMethods } from '../models/api-model';
import { apiAction } from './base-api';
import { BeneficiariesRequest } from '../../pages/arc/features/beneficiary/model/beneficiary-models';


export const getCompensationWithHandler = (employeeId: number | string, employment_id: number, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/employments/${employment_id}/compensations.json`,
		onSuccess,
		onFailure,
	});
};

export const postCompensationWithHandler = (employeeId: string | number, employmentId: string | number, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		payloadData,
		url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/employments/${employmentId}/compensations.json`,
		onSuccess,
		onFailure,
	});
};

export const patchCompensationWithHandler = (employeeId: number | string, employmentId: number, id: number, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.PATCH,
		payloadData,
		url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/employments/${employmentId}/compensations/${id}.json`,
		onSuccess,
		onFailure,
	});
};


export const postCalculateTotals = (employeeId: number | string, employment_id: number, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/employments/${employment_id}/compensations/calculate_totals.json`,
		method: HttpMethods.POST,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const getEmployment = (employeeId: number | string, employmentId: number | string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/employments/${employmentId}.json`,
		onSuccess,
		onFailure,
	});
};


export const getEmployeesList = (employerId: number | string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.benAdmin}/employers/${employerId}/employees.json`,
		onSuccess,
		onFailure,
	});
};

export const postScheduledHours = (employeeId: number | string, employmentId: number, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
    return apiAction({
        method: HttpMethods.POST,
        url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/employments/${employmentId}/scheduled_hours.json`,
        payloadData,
        onSuccess,
        onFailure,
    });
};

export const patchScheduledHours = (employeeId: number | string, employmentId: number, scheduledHoursId: number, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
    return apiAction({
        method: HttpMethods.PATCH,
        url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/employments/${employmentId}/scheduled_hours/${scheduledHoursId}.json`,
        payloadData,
        onSuccess,
        onFailure,
    });
};

export const getNonStipendiaryEmployment = (employeeId: string | number, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/non_stipendiary_positions.json`,
		onSuccess,
		onFailure,
	});
};

export const postPositionTitle = (employeeId: number | string, employmentId: number, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
    return apiAction({
        method: HttpMethods.POST,
        url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/employments/${employmentId}/position_titles.json`,
        payloadData,
        onSuccess,
        onFailure,
    });
};

export const patchPositionTitle = (employeeId: number | string, employmentId: number | string, positionId: number, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
    return apiAction({
        method: HttpMethods.PATCH,
        url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/employments/${employmentId}/position_titles/${positionId}.json`,
        payloadData,
        onSuccess,
        onFailure,
    });
};

export const postNonStipEmployment = (employeeId: number | string, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
    return apiAction({
        method: HttpMethods.POST,
        url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/non_stipendiary_positions.json`,
        payloadData,
        onSuccess,
        onFailure,
    });
};


export const postNonStipPositionTitle = (employeeId: number | string, employmentId: number, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
    return apiAction({
        method: HttpMethods.POST,
        url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/non_stipendiary_positions/${employmentId}/position_titles.json`,
        payloadData,
        onSuccess,
        onFailure,
    });
};

export const patchNonStipPositionTitle = (employeeId: number | string, employmentId: number, positionId: number, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
    return apiAction({
        method: HttpMethods.PATCH,
        url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/non_stipendiary_positions/${employmentId}/position_titles/${positionId}.json`,
        payloadData,
        onSuccess,
        onFailure,
    });
};

export const addUnpaidLeaveWithHandler = (employeeId: string | number, employmentId: number, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		payloadData,
		url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/employments/${employmentId}/unpaid_leaves.json`,
		onSuccess,
		onFailure,
	});
};


export const getSummaryPlan = (institutionClientNumber: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.GET,
		url: `${ApiEndpoint.benAdmin}/employers/${institutionClientNumber}/plan_adoptions.json`,
		onSuccess,
		onFailure,
	});
};

export const getEmploymentPlans = (employmentId: number, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.GET,
		url: `${ApiEndpoint.benAdmin}/employments/${employmentId}/plans.json`,
		onSuccess,
		onFailure,
	});
};

export const postPensionEnrollment = (employeeId: string, employmentId: number, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/employments/${employmentId}/enrollments.json`,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const terminateEmployee = (employeeId: string, employmentId: number, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.PATCH,
		url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/employments/${employmentId}/terminate.json`,
		payloadData,
		onSuccess,
		onFailure,
	});
};
export const terminateNonStipEmployee = (employeeId: string, nonStipId: number, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.PATCH,
		url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/non_stipendiary_positions/${nonStipId}/terminate.json`,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const deleteEmployment = (employeeId: string, employmentId: number, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.DELETE,
		url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/employments/${employmentId}.json`,
		onSuccess,
		onFailure,
	});
};

export const deleteNonStipEmployment = (employeeId: string, positionTitleId: number, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.DELETE,
		url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/non_stipendiary_positions/${positionTitleId}.json`,
		onSuccess,
		onFailure,
	});
};


export const getBatchCompensations = (employerId: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.GET,
		url: `${ApiEndpoint.benAdmin}/employers/${employerId}/batch_compensations.json`,
		onSuccess,
		onFailure,
	});
};


export const compensationPollJob = (url: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.GET,
		url,
		onSuccess,
		onFailure,
		contentType: '',
	});
};

export const validateCompensationFile = (employerId: string, payload: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.benAdmin}/employers/${employerId}/batch_compensations/validate`,
		onSuccess,
		onFailure,
		contentType: 'multipart/form-data',
		payloadData: payload,
	});
};

export const uploadCompensationFile = (employerId: string, payload: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.benAdmin}/employers/${employerId}/batch_compensations`,
		onSuccess,
		onFailure,
		contentType: 'multipart/form-data',
		payloadData: payload,
	});
};


export const getEmployeeStatus = (employeeGuid: string, employmentId: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.benAdmin}/employees/${employeeGuid}/employments/${employmentId}/details`,
		onSuccess,
		onFailure,
	});
};


export const getProductTerminationDates = (employeeId: string, employmentId: string | number, date: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any, mockApiHandler?: MockApiHandler, isLoa?: boolean) => {
	return apiAction({
		method: HttpMethods.GET,
		url: `${ApiEndpoint.personPrc}/employee/${employeeId}/employment/${employmentId}/terminations/${date}${isLoa ? '?terminationType=LOA' : ''}`,
		onSuccess,
		onFailure,
		mockApiHandler,
	});
};




export const getEmployments = (employeeId: number | string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/employments.json`,
		onSuccess,
		onFailure,
	});
};



export const getBeneficiaries = (employeeId: number | string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/beneficiaries.json`,
		onSuccess,
		onFailure,
	});
};

export const createNewBeneficiary = (employeeId: number | string, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/beneficiary_relationships.json`,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const postBeneficiaries = (employeeId: number | string, payloadData: BeneficiariesRequest, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/beneficiaries.json`,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const getBeneficiariesRelationships = (employeeId: number | string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/beneficiary_relationships.json`,
		onSuccess,
		onFailure,
	});
};

export const getBenefitOptions = (employerId: number | string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any, customQuery?: string): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.mlps}/employers/${employerId}/benefit_options.json${customQuery ?? ''}`,
		onSuccess,
		onFailure,
	});
};


export const getDbPlanDetail = (institutionClientNumber: string, id: number, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.GET,
		url: `${ApiEndpoint.benAdmin}/employers/${institutionClientNumber}/db_plans/${id}`,
		onSuccess,
		onFailure,
	});
};

export const getDcPlanDetail = (institutionClientNumber: string, id: number, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.GET,
		url: `${ApiEndpoint.benAdmin}/employers/${institutionClientNumber}/dc_plans/${id}`,
		onSuccess,
		onFailure,
	});
};

export const getRsvpPlanDetail = (institutionClientNumber: string, id: number, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.GET,
		url: `${ApiEndpoint.benAdmin}/employers/${institutionClientNumber}/rsvp_plans/${id}`,
		onSuccess,
		onFailure,
	});
};

export const getBenefitEndDate = (
	employeeId: number | string,
	employment: number,
	hours: string | number,
	start_date: string,
	change_due_to_illness: string,
	onSuccess: (response, dispatch?: Dispatch<any>) => any,
	onFailure?: (dispatch?: Dispatch<any>) => any,
): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.benAdmin}/employees/${employeeId}/employments/${employment}/scheduled_hours/benefit_end_dates?hours=${hours}&start_date=${start_date}&change_due_to_illness=${change_due_to_illness}`,
		onSuccess,
		onFailure,
	});
};

export const validateDbPlan = (institutionClientNumber: string, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.benAdmin}/employers/${institutionClientNumber}/db_plans/validate`,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const postDbPlan = (institutionClientNumber: string, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.benAdmin}/employers/${institutionClientNumber}/db_plans`,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const validateLayDcPlan = (institutionClientNumber: string, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.benAdmin}/employers/${institutionClientNumber}/dc_plans/validate`,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const postLayDcPlan = (institutionClientNumber: string, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.benAdmin}/employers/${institutionClientNumber}/dc_plans`,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const validateRsvpPlan = (institutionClientNumber: string, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.benAdmin}/employers/${institutionClientNumber}/rsvp_plans/validate`,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const validateLayDcAmendPlan = (institutionClientNumber: string, planId: string, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.benAdmin}/employers/${institutionClientNumber}/dc_plans/${planId}/amendments/validate`,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const validateRsvpAmendPlan = (institutionClientNumber: string, planId: string, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.benAdmin}/employers/${institutionClientNumber}/rsvp_plans/${planId}/amendments/validate`,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const postRsvpPlan = (institutionClientNumber: string, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.benAdmin}/employers/${institutionClientNumber}/rsvp_plans`,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const postLayDcAmendPlan = (institutionClientNumber: string, planId: string, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.benAdmin}/employers/${institutionClientNumber}/dc_plans/${planId}/amendments`,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const postRsvpAmendPlan = (institutionClientNumber: string, planId: string, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.benAdmin}/employers/${institutionClientNumber}/rsvp_plans/${planId}/amendments`,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const getGhlPlans = (institutionClientNumber: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.GET,
		url: `${ApiEndpoint.mlps}/employers/${institutionClientNumber}/plan_offerings`,
		onSuccess,
		onFailure,
	});
};